import { render, staticRenderFns } from "./ProfileStrength.vue?vue&type=template&id=10883602&"
import script from "./ProfileStrength.vue?vue&type=script&lang=js&"
export * from "./ProfileStrength.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports